<div class="contenedor" >
    <div class="title">
        <img class="imagenLogo" src="../../../assets/imagenes/logo.png" alt="BEX Patagonia">
    </div>

    <div [ngStyle]="{'height': height}"></div>
</div>
